import React, { useState } from 'react';

const DOCUMENTS = [
  {
    id: 'A003',
    name: 'A003 — Client Agreement',
    filename: 'A003-client-agreement.pdf',
    size: '123.75 KB',
    category: 'General',
    description: 'Standard client agreement outlining terms, conditions and obligations between AQMCS and the client.',
  },
  {
    id: 'A014',
    name: 'A014 — FBO Application Form',
    filename: 'A014-FBO-Application-Form.pdf',
    size: '141.32 KB',
    category: 'General',
    description: 'Application form for Food Business Operators (FBO) seeking certification services from AQMCS.',
  },
  {
    id: 'A017',
    name: 'A017 — Fee Structure',
    filename: 'A017-fee-structure.pdf',
    size: '95.94 KB',
    category: 'General',
    description: 'Detailed fee structure for AQMCS certification and inspection services.',
  },
  {
    id: 'AA001',
    name: 'AA001 — FBO Application Form',
    filename: 'AA001FBO-Application-Form.pdf',
    size: '446.69 KB',
    category: 'Food Safety',
    description: 'Comprehensive Food Business Operator application form for food safety inspection and certification.',
  },
  {
    id: 'AA032',
    name: 'AA032 — Impartiality Policy',
    filename: 'AA032-Impartiality-Policy.pdf',
    size: '96.7 KB',
    category: 'Policies',
    description: 'AQMCS impartiality policy ensuring independence and objectivity in all audit and inspection activities.',
  },
  {
    id: 'AA051',
    name: 'AA051 — Code of Conduct',
    filename: 'AA051-code-of-conduct.pdf',
    size: '102.72 KB',
    category: 'Policies',
    description: 'Code of conduct for AQMCS auditors and staff, outlining ethical obligations and professional standards.',
  },
  {
    id: 'AA058',
    name: 'AA058 — Application Form for BEMC Scheme',
    filename: 'AA058-Application-Form-for-BEMC-Scheme.pdf',
    size: '170.67 KB',
    category: 'BEMC',
    description: 'Application form for the Biomedical Equipment Maintenance Certification (BEMC) Scheme.',
  },
  {
    id: 'AA059',
    name: 'AA059 — BEMC Scheme Certification Process',
    filename: 'AA059-BEMC-Scheme-certification-process.pdf',
    size: '97.56 KB',
    category: 'BEMC',
    description: 'Step-by-step guide to the BEMC Scheme certification process including timelines and requirements.',
  },
  {
    id: 'FS001',
    name: 'FS001 — Application Form',
    filename: 'FS001-Application-Form.pdf',
    size: '28.36 KB',
    category: 'Food Safety',
    description: 'General food safety inspection application form.',
  },
  {
    id: 'FS002',
    name: 'FS002 — Inspection Agreement (FSIS)',
    filename: 'FS002-inspection-agreement-FSIS.pdf',
    size: '39.69 KB',
    category: 'Food Safety',
    description: 'Inspection agreement for Food Safety Inspection Services (FSIS), covering scope, terms and conditions.',
  },
  {
    id: 'FS003',
    name: 'FS003 — Fee Structure for FSIS',
    filename: 'FS003-fee-strucutre-for-FSIS.pdf',
    size: '18.15 KB',
    category: 'Food Safety',
    description: 'Fee structure specific to Food Safety Inspection Services (FSIS).',
  },
  {
    id: 'FS010',
    name: 'FS010 — Publicly Available Information',
    filename: 'FS010-publically-available-information.pdf',
    size: '16.08 KB',
    category: 'Food Safety',
    description: 'Publicly available information document as required under accreditation standards.',
  },
  {
    id: '',
    name: 'Hygiene Rated FEs',
    filename: 'Hygiene-Rated-FEs.pdf',
    size: '22.90 KB',
    category: 'Food Safety',
    description: 'Publicly available information document as required under accreditation standards.',
  },
  {
    id: 'PM014',
    name: 'PM014 — Procedure for Complaint',
    filename: 'PM014-procedure-for-Complaint.pdf',
    size: '99.58 KB',
    category: 'Procedures',
    description: 'Formal procedure for raising and resolving complaints related to AQMCS services.',
  },
  {
    id: 'PM015',
    name: 'PM015 — Procedure for Appeal',
    filename: 'PM015-procedure-for-Appeal.pdf',
    size: '101.24 KB',
    category: 'Procedures',
    description: 'Formal appeal procedure for clients who wish to challenge an inspection or certification decision.',
  },
  {
    id: 'PM020',
    name: 'PM020 — Procedure for Fire Safety Inspection',
    filename: 'PM020-procedure-for-fire-safety-inspection.pdf',
    size: '107.73 KB',
    category: 'Procedures',
    description: 'Detailed procedure document outlining the methodology and requirements for fire safety inspections.',
  },
];

const CATEGORIES = ['All', 'General', 'Food Safety', 'BEMC', 'Policies', 'Procedures'];

const CATEGORY_COLORS = {
  General:    { bg: 'rgba(0,175,239,.1)',  color: '#0093cc' },
  'Food Safety': { bg: 'rgba(13,158,106,.1)', color: '#0d9e6a' },
  BEMC:       { bg: 'rgba(124,58,237,.1)', color: '#7c3aed' },
  Policies:   { bg: 'rgba(217,119,6,.1)',  color: '#d97706' },
  Procedures: { bg: 'rgba(12,30,53,.1)',   color: '#0c1e35' },
};

// eslint-disable-next-line no-unused-vars
function copyToClipboard(text) {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  } else {
    const el = document.createElement('textarea');
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }
}

function DocRow({ doc, onCopy, copied }) {
  const cat = CATEGORY_COLORS[doc.category] || CATEGORY_COLORS.General;
  const DocLink = `./documents/${encodeURIComponent(doc.filename)}`;

  return (
    <div className="doc-row" aria-label={doc.name}>
      {/* Icon + info */}
      <div className="doc-row-left">
        <div className="doc-pdf-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" stroke="#00AFEF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            <polyline points="14 2 14 8 20 8" stroke="#00AFEF" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
            <text x="6" y="18" fontSize="5" fill="#00AFEF" fontWeight="bold" fontFamily="sans-serif">PDF</text>
          </svg>
        </div>
        <div className="doc-info">
          <div className="doc-name">{doc.name}</div>
          <div className="doc-meta">
            <span className="doc-cat-badge" style={{ background: cat.bg, color: cat.color }}>{doc.category}</span>
            <span className="doc-size">{doc.size}</span>
          </div>
          {doc.description && <div className="doc-desc">{doc.description}</div>}
        </div>
      </div>

      {/* Actions */}
      <div className="doc-actions">
        <a
          href={DocLink}
          target="_blank"
          rel="noopener noreferrer"
          className="doc-btn doc-btn-outline"
          title="Open document"
          aria-label={`Open ${doc.name}`}
        >
          <span>⬡</span> Open
        </a>
        <a
          href={DocLink}
          download={doc.filename}
          className="doc-btn doc-btn-blue"
          title="Download document"
          aria-label={`Download ${doc.name}`}
        >
          <span>↓</span> Download
        </a>
        {/* <button
          className={`doc-btn doc-btn-copy${copied ? ' copied' : ''}`}
          onClick={() => { copyToClipboard(DocLink); onCopy(doc.id); }}
          title="Copy link"
          aria-label={`Copy link for ${doc.name}`}
        >
          {copied ? '✓ Copied' : '⧉ Copy Link'}
        </button> */}
      </div>
    </div>
  );
}

export default function DocumentsPage({ setPage }) {
  const [activeCategory, setActiveCategory] = useState('All');
  const [search, setSearch] = useState('');
  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = (id) => {
    setCopiedId(id);
    setTimeout(() => setCopiedId(null), 2000);
  };

  const filtered = DOCUMENTS.filter((doc) => {
    const matchesCat = activeCategory === 'All' || doc.category === activeCategory;
    const matchesSearch =
      doc.name.toLowerCase().includes(search.toLowerCase()) ||
      doc.category.toLowerCase().includes(search.toLowerCase()) ||
      doc.filename.toLowerCase().includes(search.toLowerCase());
    return matchesCat && matchesSearch;
  });

  // eslint-disable-next-line no-unused-vars
  const counts = CATEGORIES.reduce((acc, cat) => {
    acc[cat] = cat === 'All' ? DOCUMENTS.length : DOCUMENTS.filter((d) => d.category === cat).length;
    return acc;
  }, {});

  return (
    <main className="page" id="main-content">
      {/* ── PAGE HERO ── */}
      <header className="page-hero">
        <div className="ph-inner">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <span onClick={() => { setPage('Home'); window.scrollTo(0, 0); }}>Home</span>
            <span className="sep">/</span>
            <span className="cur">Documents</span>
          </nav>
          <h1>Documents & Downloads</h1>
          <p>
          </p>
        </div>
      </header>

      {/* ── INTRO BANNER
      <div className="docs-intro-banner">
        <div className="sec-inner">
          <div className="docs-intro-grid">
            <div className="docs-intro-text">
              <h2>Understanding Your Documentation</h2>
              <p>
                Below you will find all the forms, agreements, policies and procedures you need
                for your certification journey with AQMCS. Documents are organised by category
                for easy navigation.
              </p>
            </div>
            <div className="docs-need-help">
              <div className="docs-help-card">
                <div className="docs-help-icon">💬</div>
                <h4>Need Assistance?</h4>
                <p>
                  If you have any questions about the required documents or need help with your
                  submission, our support team is here to assist you.
                </p>
                <button
                  className="btn-blue"
                  style={{ fontSize: '0.88rem', padding: '0.7rem 1.4rem' }}
                  onClick={() => { setPage('Contact'); window.scrollTo(0, 0); }}
                >
                  Contact Support →
                </button>
              </div>
            </div>
          </div>
        </div>
      </div> ── */}

      {/* ── DOCUMENTS SECTION ── */}
      <section className="section" aria-labelledby="docs-heading">
        <div className="sec-inner">
          {/* Search + Filter Bar */}
          <div className="docs-toolbar">
            <div className="docs-search-wrap">
              <span className="docs-search-icon" aria-hidden="true">🔍</span>
              <input
                type="search"
                placeholder="Search documents by name…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="docs-search"
                aria-label="Search documents"
              />
              {search && (
                <button className="docs-search-clear" onClick={() => setSearch('')} aria-label="Clear search">×</button>
              )}
            </div>
              {/*
            <div className="docs-filter-tabs" role="tablist" aria-label="Filter by category">
              {CATEGORIES.map((cat) => (
                <button
                  key={cat}
                  role="tab"
                  aria-selected={activeCategory === cat}
                  className={`docs-filter-tab${activeCategory === cat ? ' active' : ''}`}
                  onClick={() => setActiveCategory(cat)}
                >
                  {cat}
                  <span className="docs-filter-count">{counts[cat]}</span>
                </button>
              ))}
            </div> */}

          </div>

          {/* Results count */}
          <div className="docs-results-info" aria-live="polite">
            {search || activeCategory !== 'All'
              ? `Showing ${filtered.length} of ${DOCUMENTS.length} documents`
              : `${DOCUMENTS.length} documents available`}
          </div>

          {/* Document List */}
          {filtered.length > 0 ? (
            <div className="docs-list" role="list">
              {filtered.map((doc) => (
                <DocRow
                  key={doc.id}
                  doc={doc}
                  onCopy={handleCopy}
                  copied={copiedId === doc.id}
                />
              ))}
            </div>
          ) : (
            <div className="docs-empty">
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>📂</div>
              <h3>No documents found</h3>
              <p>Try adjusting your search or category filter.</p>
              <button className="btn-blue" style={{ marginTop: '1rem' }} onClick={() => { setSearch(''); setActiveCategory('All'); }}>
                Clear Filters
              </button>
            </div>
          )}
        </div>
      </section>

      {/* ── NOTICE BANNER
      <div className="docs-notice">
        <div className="sec-inner">
          <div className="docs-notice-inner">
            <span className="docs-notice-icon">ℹ️</span>
            <div>
              <strong>Important:</strong> All documents are provided for information and application purposes.
              For the most current versions, please contact our team. Documents are subject to periodic updates
              in line with accreditation requirements and regulatory changes.
            </div>
          </div>
        </div>
      </div> ── */}

      {/* ── CTA ── */}
      <div className="cta-banner">
        <div className="cta-inner">
          <h2>Ready to Start Your <span className="cta-accent">Certification Journey?</span></h2>
          <p>
            Download the relevant documents, complete them, and reach out to our team. We'll
            guide you through every step of the process.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              className="btn-blue"
              onClick={() => { setPage('Contact'); window.scrollTo(0, 0); }}
              style={{ fontSize: '1rem', padding: '1rem 2.5rem' }}
            >
              Contact Us →
            </button>
            <button
              className="btn-ghost"
              onClick={() => { setPage('Services'); window.scrollTo(0, 0); }}
              style={{ fontSize: '1rem', padding: '1rem 2.5rem' }}
            >
              View Services
            </button>
          </div>
        </div>
      </div>
    </main>
  );
}
